// Bundle de la busqueda instantanea (beta). Solo se carga para los usuarios
// del flag SEARCH_INSTANT_USER_IDS (ver front.common.partials.instant-search).
// Reutiliza el componente <products> del cercador (grid + filtros + paginacion),
// alimentado desde el endpoint JSON en vez del render Blade.
// Sin ant-design-vue ni vue-paginate: ningun .vue del front usa <a-*> ni
// <paginate> (la paginacion es components/PageControl.vue). Cargarlos aqui
// eran ~1,5 MiB de bundle muertos (docs/modernization/01-audit.md, F1.5).
import Searcher from "../searcher/Searcher";
import InstantSearch from "./InstantSearch.vue";
import { createPageApp } from "@/createPageApp";

const app = createPageApp();

app.component("products", Searcher);
app.component("instant-search", InstantSearch);

app.mount("#instant-search-app");
